// src/containers/layout/receptionist-shell.tsx
//
// Which chrome a receptionist screen sits in.
//
// ourteam staff reach the console from the platform sidebar like any other
// page — Workspaces, then a merchant's row — so they keep the platform's own
// layout. One sidebar, one set of habits, and the rest of their work still one
// click away. Before this they crossed into an 80px rail showing a single
// item and lost every other product they had just been using.
//
// `receptionist-client` keeps the dedicated rail. Its nav is seven items for
// one merchant (Bookings, Services, Conversation, Behaviour, Learn, Staff,
// Business) and does not collapse into a single sidebar entry, so moving it
// would be a design question rather than a rename.
//
// Straight copy of OuraShell (./oura-shell.tsx), which answered the same
// question for the same reason.

import type { ReactNode } from "react";
import AuthLayout from "./auth";
import ReceptionistAuthLayout from "./receptionist-auth";
import { useReceptionistRole } from "@receptionist/role";

export default function ReceptionistShell({ children }: { children: ReactNode }) {
    const role = useReceptionistRole();
    if (role === "receptionist-staff") return <AuthLayout>{children}</AuthLayout>;
    return <ReceptionistAuthLayout>{children}</ReceptionistAuthLayout>;
}
